"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = require("react");
var ClickableTooltip_1 = require("../../common/ClickableTooltip/ClickableTooltip");
var reservationLabelStyles_1 = require("./reservationLabelStyles");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var react_intl_1 = require("react-intl");
var cache_1 = require("../../../../../common/graphql/cache");
var client_1 = require("@apollo/client");
var JourneyTypes_1 = require("../../../../../../../../common/enum/JourneyTypes");
var ReservationLabel = function () {
    var intl = react_intl_1.useIntl();
    var styles = reservationLabelStyles_1.default();
    var journeyType = client_1.useReactiveVar(cache_1.activeJourneyType);
    if (journeyType === JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP) {
        return null;
    }
    return (<core_1.Box component="span" data-test="summary:reservation" className={styles.container}>
      <core_1.Typography className={styles.amount} data-test="summary:reservation-amount">
        <Translation_1.default id={'trans__checkout__confirmation_page__summary__reservation_reservation_fee'}/>
      </core_1.Typography>
      <core_1.Typography className={styles.label} data-test="summary:reservation-label">
        <Translation_1.default id={'trans__fincalc__cash_breakdown__refundable_reservation_fee_label'}/>
      </core_1.Typography>
      <ClickableTooltip_1.default>
        <>
          <icons_1.Close className={styles.tooltipCloseIcon} data-test="common:mui:tooltip-close-button"/>
          <core_1.Typography className={styles.tooltipContent} dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: 'trans__checkout__confirmation_page__summary__reservation_reservation_tooltip',
        }),
    }} data-test="summary:reservation-tooltip-content"/>
        </>
      </ClickableTooltip_1.default>
    </core_1.Box>);
};
exports.default = ReservationLabel;
